import * as Sentry from '@sentry/react'

export type AgentEvent = {
  type: 'text' | 'tool_use' | 'tool_result' | 'done' | 'error' | 'thinking'
  content?: string
  name?: string
  input?: Record<string, unknown>
  result?: string
}

export function createAgentSocket(
  onEvent: (event: AgentEvent) => void,
  onClose?: () => void,
) {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const ws = new WebSocket(`${protocol}//${window.location.host}/api/agent/ws`)

  ws.onmessage = (e) => {
    try {
      const event: AgentEvent = JSON.parse(e.data)
      if (event.type === 'error') {
        Sentry.captureMessage(`Agent error: ${event.content ?? 'Unknown'}`, 'error')
      }
      onEvent(event)
    } catch {
      console.error('Failed to parse agent event:', e.data)
    }
  }

  ws.onclose = () => onClose?.()

  const send = (prompt: string) => {
    if (ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ prompt }))
    }
  }

  const close = () => ws.close()

  return { send, close, ws }
}
